import {SellerErrorsFactory} from '../Errors/factory.js'
import {ContactModelSellerRequest} from './ContactModelSellerRequest.js'
import {GetCloseDealersRequest} from './GetCloseDealersRequest.js'
import {GetInstantOfferSellerRequest} from './GetInstantOfferSellerRequest.js'
import {GetRecommendedPriceSellerRequest} from './GetRecommendedPriceSellerRequest.js'
import {GetSellerRequest} from './GetSellerRequest.js'
import {GetSimulatedInstantOfferSellerRequest} from './GetSimulatedInstantOfferSellerRequest.js'

export class SellerRequestsFactory {
  static contactModelSellerRequest =
    ({config}) =>
    ({
      captchaToken,
      email,
      hasAcceptedTermsAndConditions,
      makeId,
      modelId,
      name,
      phone,
      postalCode,
      surname,
      type,
      userId
    }) => {
      ContactModelSellerRequest.validate({
        config,
        email,
        hasAcceptedTermsAndConditions,
        name,
        userId,
        type,
        phone,
        contactValidationSellerError: SellerErrorsFactory.contactValidationSellerError,
        emptyEmailSellerError: SellerErrorsFactory.emptyEmailSellerError,
        emptyNameSellerError: SellerErrorsFactory.emptyNameSellerError,
        termsAndConditionsNotAcceptedSellerError: SellerErrorsFactory.termsAndConditionsNotAcceptedSellerError,
        invalidEmailSellerError: SellerErrorsFactory.invalidEmailSellerError,
        invalidPhoneSellerError: SellerErrorsFactory.invalidPhoneSellerError
      })

      return new ContactModelSellerRequest({
        captchaToken,
        email,
        hasAcceptedTermsAndConditions,
        makeId,
        modelId,
        name,
        phone,
        postalCode,
        surname,
        type,
        userId
      })
    }

  static getCloseDealersRequest = ({instantOfferEntity, isNextAppointment = false} = {}) => {
    GetCloseDealersRequest.validate({
      instantOfferEntity,
      invalidRequestErrorFactory: SellerErrorsFactory.invalidRequestSellerError
    })

    return new GetCloseDealersRequest({instantOfferEntity, isNextAppointment})
  }

  static getSimulatedInstantOfferSellerRequest = ({
    bodyTypeDoors,
    dealerType,
    fuelId,
    makeId,
    makeName,
    mileage,
    modelId,
    modelName,
    postalCode,
    transmissionTypeId,
    versionId,
    versionName,
    year
  }) => {
    GetSimulatedInstantOfferSellerRequest.validate({
      bodyTypeDoors,
      dealerType,
      fuelId,
      makeId,
      makeName,
      mileage,
      modelId,
      modelName,
      postalCode,
      transmissionTypeId,
      versionId,
      versionName,
      year,
      invalidSellerRequestSellerError: SellerErrorsFactory.invalidSellerRequestSellerError
    })

    return new GetSimulatedInstantOfferSellerRequest({
      bodyTypeDoors,
      dealerType,
      fuelId,
      makeId,
      makeName,
      mileage,
      modelId,
      modelName,
      postalCode,
      transmissionTypeId,
      versionId,
      versionName,
      year
    })
  }

  static getInstantOfferSellerRequest = ({
    bodyTypeDoors,
    condition,
    dealerType,
    email,
    fuelId,
    licensePlate,
    makeId,
    makeName,
    mileage,
    modelId,
    modelName,
    name,
    phone,
    postalCode,
    transmissionTypeId,
    versionId,
    versionName,
    year
  }) => {
    return new GetInstantOfferSellerRequest({
      bodyTypeDoors,
      condition,
      dealerType,
      email,
      fuelId,
      licensePlate,
      makeId,
      makeName,
      mileage,
      modelId,
      modelName,
      name,
      phone,
      postalCode,
      transmissionTypeId,
      versionId,
      versionName,
      year
    })
  }

  static getRecommendedPriceSellerRequest = ({queryParams}) => new GetRecommendedPriceSellerRequest({queryParams})

  static getSellerRequest = ({contractId, userId, isPrivate, isDealer} = {}) => {
    GetSellerRequest.validate({
      contractId,
      userId,
      invalidSellerRequestSellerError: SellerErrorsFactory.invalidSellerRequestSellerError
    })

    return new GetSellerRequest({contractId, userId, isPrivate, isDealer})
  }
}
